import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useTranslate } from "@/hooks";
import { colorPrimary, colorSecondary } from "@/constants/colors";
import { TCustomCheckboxProps } from "./CustomCheckbox.props";
import { Hint } from "@/HOC";

const CustomCheckbox = ({
	label,
	hint = "",
	hintPosition,
	marginLeft = -11,
	checkboxSize,
	fontSize = 13,
	gap = 0,
	showCheckbox = true, // Новый пропс
	...props
}: TCustomCheckboxProps & { showCheckbox?: boolean }): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Hint
			hint={hint}
			position={hintPosition}
			PopperProps={{
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [0, -6],
						},
					},
				],
			}}
		>
			{showCheckbox ? (
				<FormControlLabel
					sx={{
						color: colorPrimary,
						marginBlock: "-3px -7px",
						gap: `${gap}px`,
						marginLeft: `${marginLeft}px`,
						marginRight: "0px",
						".MuiTypography-root": { fontSize: fontSize },
					}}
					control={
						<Checkbox
							size="small"
							{...props}
							sx={{
								"&.Mui-checked": {
									color: colorPrimary,
									"&.Mui-checked": {
										color: colorSecondary,
									},
								},
								"& .MuiSvgIcon-root": checkboxSize
									? {
											fontSize: checkboxSize,
									  }
									: {},
								...props.sx,
							}}
						/>
					}
					label={translate(label)}
				/>
			) : (
				<Typography
					title={translate(label)}
					sx={{
						fontSize: fontSize,
						marginBlock: "-5px -7px",
						marginLeft: `${marginLeft}px`,
						cursor: "pointer", // или "pointer" если нужно сохранить кликабельность
						marginRight: "3px",
						width: "16px",
						textAlign: "center",
					}}
					onClick={
						props.onChange
							? () => {
									// Если нужно сохранить возможность переключать состояние по клику на текст
									if (props.disabled) return;
									props.onChange?.(
										{
											target: { checked: !props.checked },
										} as any,
										!props.checked
									);
							  }
							: undefined
					}
				>
					<FontAwesomeIcon icon={props.checked ? faXmark : faCheck} />
				</Typography>
			)}
		</Hint>
	);
};

export default CustomCheckbox;
